import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { hydrateContainer } from '@as-react/hydrater';
import { Logger } from '@as-react/logger';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductPlacementCopyAPI from '../../../api/ProductPlacementCopyAPI';
import { availableComponents, renderingTools } from '../../../index';
import { getPPCPositionTypesByMarket } from '../../../util/PPCUtil';
const YOUTUBE_SELECTOR = '.youtube-video';
export const useProductPlacementCopyBox = (ppc) => {
    const { market, isInAuthorMode, rootWithLanguageSuffix, root, locale, translationLang } = useAemConfig();
    const [content, setContent] = useState(null);
    const renderedContainerElement = useRef(null);
    const { i18n } = useTranslation();
    const isExternal = () => ppc.text && ppc.text.indexOf('/') === 0;
    const isPPCHasVideo = () => { var _a; return (_a = renderedContainerElement === null || renderedContainerElement === void 0 ? void 0 : renderedContainerElement.current) === null || _a === void 0 ? void 0 : _a.querySelector(YOUTUBE_SELECTOR); };
    const PPCPositionTypes = getPPCPositionTypesByMarket(market);
    const getContent = () => {
        if (isExternal()) {
            ProductPlacementCopyAPI.fetchPPC(ppc.text, isInAuthorMode ? `${rootWithLanguageSuffix}/` : root)
                .then(data => setContent(data))
                .catch(Logger.logError);
        }
        else {
            setContent(ppc.text);
        }
    };
    useEffect(() => {
        getContent();
    }, [ppc]);
    useEffect(() => {
        const container = renderedContainerElement.current;
        if (!content || !container || !isExternal())
            return;
        return hydrateContainer({ availableComponents, root: container, renderingTools, locale, translationLang, i18n }, () => isPPCHasVideo() && EventUtil.dispatch(EventEnum.NEW_VIDEO_IFRAME_ADDED));
    }, [content]);
    return {
        content,
        renderedContainerElement,
        PPCPositionTypes,
        isExternal,
    };
};
